export enum EventListener {
  visibilitychange = "visibilitychange",
}
